import { httpsCallable } from 'firebase/functions';

import { IAdmin } from 'types';
import { functions } from 'config/firebase';
import { COLLECTIONS, FUNCTIONS } from 'constants/collections';
import {
  getDocument,
  getDocuments,
  updateDocument,
  createDocumentWithID,
} from 'utils/firebase';

export const list = () => {
  return getDocuments({ collection: COLLECTIONS.ADMINS });
};

export const get = (id: string) => {
  return getDocument({ collection: COLLECTIONS.ADMINS, id });
};

export const create = (id: string, data: Partial<IAdmin>) => {
  return createDocumentWithID({ collection: COLLECTIONS.ADMINS, data, id });
};

export const update = (id: string, data: Partial<IAdmin>) => {
  return updateDocument({ collection: COLLECTIONS.ADMINS, id, data });
};

export const createFirebaseAdmin = (email: string, password: string) => {
  const callable = httpsCallable<unknown, { adminID: string }>(
    functions,
    FUNCTIONS.CREATE_ADMIN
  );
  return callable({ email, password });
};

export const sendNotification = () => {
  const callable = httpsCallable(functions, 'sendTestPushNotification');
  return callable();
};
